import { useMediaQuery } from '@material-ui/core';
export function useIsMobile() {
    return useMediaQuery((theme) => theme.breakpoints.down('sm'));
}
